const { createSelector } = require('reselect')

const selectAlert = state => state.ratingDomain.rating;

const rating = () => createSelector(
  [selectAlert],
  alert => alert.data,
)

const ratingError = () => createSelector(
  [selectAlert],
  alert => alert.error,
)

const ratingLoading = () => createSelector(
  [selectAlert],
  alert => alert.loading,
)

module.exports = {
  rating,
  ratingError,
  ratingLoading,
}
